import { fetchRecipes } from "../../helpers/helper_functions";
import {
  fetchRecipesStartAction,
  fetchRecipesFailureAction,
  fetchRecipesSuccessAction,
  setNextPageUrlAction,
} from "../actions/actions";

export const startRecipeSearchThunk =
  (nextUrl = null) =>
  async (dispatch, getState) => {
    const state = getState();
    const ingredients = state.ingredients.join(",");
    const searchQuery = state.searchQuery;

    if (!ingredients || !searchQuery) return;

    try {
      dispatch(fetchRecipesStartAction());

      let newHits = [];
      let newNext = nextUrl;
      let currentUrl = nextUrl;

      do {
        const { hits, next } = await fetchRecipes(
          ingredients,
          searchQuery,
          currentUrl,
        );
        newHits = hits;
        newNext = next;
        currentUrl = newNext;
      } while (newHits.length === 0 && newNext);

      dispatch(fetchRecipesSuccessAction(newHits, !!nextUrl));
      dispatch(setNextPageUrlAction(newNext));
    } catch (error) {
      dispatch(fetchRecipesFailureAction(error.message));
    }
  };
